export class FinancePortalService {
    constructor(http, config) {
        this.http = http;
        const servicePath = config?.servicePath ?? FinancePortalService.DEFAULT_SERVICE_PATH;
        this.basePath = `${servicePath}/${FinancePortalService.BASE_PATH}`;
    }
    buildUrl(path) {
        const url = path ? `${this.basePath}/${path}` : this.basePath;
        return url.startsWith('/') ? url : '/' + url;
    }
    async getPending() {
        const response = await this.http.get(this.buildUrl('pending'));
        return response.data ?? [];
    }
    async approve(id) {
        const response = await this.http.put(this.buildUrl(`${id}/approve`), {});
        return response.data;
    }
    async reject(id, reason) {
        const response = await this.http.put(this.buildUrl(`${id}/reject`), { reason });
        return response.data;
    }
    async hold(id, reason) {
        const response = await this.http.put(this.buildUrl(`${id}/hold`), { reason });
        return response.data;
    }
    async getHistory() {
        const response = await this.http.get(this.buildUrl('history'));
        return response.data ?? [];
    }
    // PO Management
    async getPOPending() {
        const response = await this.http.get(this.buildUrl('po-pending'));
        return response.data ?? [];
    }
    async getPOActive() {
        const response = await this.http.get(this.buildUrl('po-active'));
        return response.data ?? [];
    }
    async updatePOSage(requestId, quotationId, data) {
        const response = await this.http.put(this.buildUrl(`${requestId}/po/${quotationId}/sage`), data);
        return response.data;
    }
    // Invoice Payment Management
    async getInvoicesPending() {
        const response = await this.http.get(this.buildUrl('invoices-pending'));
        return response.data ?? [];
    }
    async approveInvoice(invoiceId) {
        const response = await this.http.put(this.buildUrl(`invoice/${invoiceId}/approve`), {});
        return response.data;
    }
    async markInvoicePaid(invoiceId) {
        const response = await this.http.put(this.buildUrl(`invoice/${invoiceId}/pay`), {});
        return response.data;
    }
    async markInvoicePartiallyPaid(invoiceId) {
        const response = await this.http.put(this.buildUrl(`invoice/${invoiceId}/partial-pay`), {});
        return response.data;
    }
}
FinancePortalService.DEFAULT_SERVICE_PATH = 'procurements';
FinancePortalService.BASE_PATH = 'api/procurement-portal/finance';
//# sourceMappingURL=FinancePortalService.js.map